<dx-drawer
  *ngIf="user && !isAnonymousRoute"
  class="drawer"
  position="before"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [shading]="shaderEnabled"
  [(opened)]="menuOpened"
  template="drawer-template"
  [closeOnOutsideClick]="shaderEnabled"
>
  <app-side-nav
    [selectedItem]="selectedRoute"
    [userRole]="userRole"
    [tenantType]="tenantType"
    [userLocation]="userLocation"
    [showLearningPath]="isLearningPathAssigned"
    [showComplianceCategory]="isComplianceCategoryAssigned"
    class="dx-swatch-additional"
    *dxTemplate="let dataMenu of 'drawer-template'"
    (selectedItemChanged)="navigationChanged($event)"
  >
    <img *ngIf="logoUrl" class="logo" [src]="logoUrl" />
  </app-side-nav>
  <div class="container">
    <app-header
      class="layout-header"
      [user]="user"
      [iddResponsiblePerson]="iddResponsiblePerson"
      [menuToggleEnabled]="shaderEnabled"
      (menuToggle)="menuOpened = !menuOpened"
    ></app-header>
    <router-outlet *ngIf="!isIframe"></router-outlet>
    <app-download *ngIf="!isIframe"></app-download>
  </div>
</dx-drawer>

<app-onboarding-overlay 
  *ngIf="showOnboarding && !showRegistrationOnboarding && !showTenantVideo"
></app-onboarding-overlay>

@if(
  showRegistrationOnboarding &&
  pendingRegistrationFlow && 
  user
) {
  <app-registration-flow-onboarding
    [firstName]="user.firstName"
    [pendingRegistrationFlow]="pendingRegistrationFlow"
    (completed)="onRegistrationFlowOnboardingCompleted()"
  ></app-registration-flow-onboarding>
}

@if(
  showTenantVideo &&
  pendingTenantVideo
) {
  <app-tenant-video
    [tenantVideo]="pendingTenantVideo"
    (completed)="onTenantVideoCompleted()"
  ></app-tenant-video>
}

<ng-container *ngIf="isAnonymousRoute">
  <router-outlet></router-outlet>
</ng-container>